import { computed } from "vue";

import { useMedia } from "./useMedia";

export const useScreenSize = () => {
  const isMobile = useMedia("(max-width: 480px)");
  const isTablet = useMedia("(max-width: 768px)");
  const isLargeTablet = useMedia("(max-width: 985px)");
  return computed(() => {
    if (isMobile.value) {
      return "mobile";
    }
    if (isTablet.value) {
      return "tablet";
    }
    if (isLargeTablet.value) {
      return "large-tablet";
    }
    return "desktop";
  });
};
